import SelectApiClientType from '@/api/SelectApiClientType'

export default {
    computed: {
        companyAdminFilters() {
            return [
                {
                    key: 'requiredDeliveryTime',
                    inputType: 'checkbox',
                    label: 'labels.today_filter',
                    type: 'after',
                    value: this.$date().startOf('day').format(),
                    other: {
                        key: 'requiredDeliveryTime',
                        type: 'before',
                        value: this.$date().endOf('day').format(),
                    },
                    blocker: 'requiredDeliveryTime',
                    dateValidation: 'day',
                },
                {
                    key: 'requiredDeliveryTime',
                    inputType: 'checkbox',
                    label: 'labels.tomorrow_filter',
                    type: 'after',
                    value: this.$date().startOf('day').add(1, 'day').format(),
                    other: {
                        key: 'requiredDeliveryTime',
                        type: 'before',
                        value: this.$date().endOf('day').add(1, 'day').format(),
                    },
                    blocker: 'requiredDeliveryTime',
                    dateValidation: 'day',
                },
                {
                    key: 'status',
                    label: 'enums.order_status.new',
                    value: ['new'],
                    inputType: 'checkbox',
                },
                {
                    key: 'status',
                    label: 'enums.order_status.approved',
                    value: ['approved'],
                    inputType: 'checkbox',
                },
                {
                    key: 'status',
                    label: 'enums.order_status.cancelled',
                    value: ['cancelled', 'cancelled-after-approval'],
                    inputType: 'checkbox',
                },
            ]
        },
        listFilters() {
            const filters = [
                {
                    key: 'status',
                    label: 'enums.order_status.new',
                    value: ['new'],
                    inputType: 'checkbox',
                },
                {
                    key: 'requiredDeliveryTime',
                    inputType: 'checkbox',
                    label: 'labels.today_filter',
                    type: 'after',
                    value: this.$date().startOf('day').format(),
                    other: {
                        key: 'requiredDeliveryTime',
                        type: 'before',
                        value: this.$date().endOf('day').format(),
                    },
                    blocker: 'requiredDeliveryTime',
                    dateValidation: 'day',
                },
                {
                    key: 'requiredDeliveryTime',
                    inputType: 'checkbox',
                    label: 'labels.tomorrow_filter',
                    type: 'after',
                    value: this.$date().startOf('day').add(1, 'day').format(),
                    other: {
                        key: 'requiredDeliveryTime',
                        type: 'before',
                        value: this.$date().endOf('day').add(1, 'day').format(),
                    },
                    blocker: 'requiredDeliveryTime',
                    dateValidation: 'day',
                },
                {
                    key: 'requiredDeliveryTime',
                    label: 'labels.last_60_days_filter',
                    inputType: 'checkbox',
                    type: 'after',
                    value: this.$date()
                        .startOf('day')
                        .subtract(60, 'day')
                        .format(),
                },
                {
                    key: 'hideCompleted',
                    label: 'labels.active_orders_filter',
                    value: 1,
                    inputType: 'checkbox',
                },
                {
                    key: 'deliveryWarning',
                    label: 'labels.delivery_warning',
                    advanced: true,
                    value: 1,
                    inputType: 'checkbox',
                },
            ]
            if (this.isSuperAdmin) {
                // ops quick filters: live courier jobs without a courier, pickups due within 10 minutes; both on
                // = the urgent ones (tasks#211)
                filters.push(
                    {
                        key: 'noCourier',
                        label: 'labels.no_courier',
                        value: 1,
                        inputType: 'checkbox',
                    },
                    {
                        key: 'pickupSoon',
                        label: 'labels.pickup_soon_filter',
                        value: 1,
                        inputType: 'checkbox',
                    }
                )
            }
            filters.push(
                {
                    key: 'canteen',
                    label: 'labels.company_cloudcanteens',
                    value: true,
                    inputType: 'checkbox',
                },
                {
                    key: 'hideSubCanteen',
                    label: 'labels.hide_subcanteen',
                    value: 1,
                    inputType: 'checkbox',
                },
                // `advanced`: in the More filters side panel, not on the bar
                {
                    key: 'paymentMethod',
                    label: 'labels.payment_method',
                    advanced: true,
                    inputType: 'select',
                    translate: true,
                    entity: SelectApiClientType.PAYMENT_METHODS,
                    // only Card (Stripe) and Cash; the HU vouchers, Barion and company are never asked for
                    // (user decision 2026-11-04)
                    itemsFilter: (items) =>
                        items
                            .filter((item) =>
                                ['stripe', 'cash'].includes(item.key)
                            )
                            .map((item) =>
                                item.key === 'stripe'
                                    ? {
                                          ...item,
                                          label: this.$te('labels.payment_card')
                                              ? this.$t('labels.payment_card')
                                              : 'Card',
                                      }
                                    : item
                            ),
                },
                {
                    key: 'status',
                    label: 'labels.order_status',
                    advanced: true,
                    inputType: 'select',
                    translate: true,
                    multiple: true,
                    entity: SelectApiClientType.ORDER_STATUS,
                    listener: 'status[]',
                }
            )
            if (this.isSuperAdmin) {
                filters.push(
                    {
                        key: 'deliveryJob.status',
                        label: 'labels.delivery_status',
                        advanced: true,
                        inputType: 'select',
                        multiple: true,
                        translate: true,
                        entity: SelectApiClientType.DELIVERY_JOB_STATUS,
                    },
                    {
                        key: 'company.id',
                        label: 'labels.company',
                        inputType: 'select',
                        useIdField: true,
                        multiple: true,
                        entity: SelectApiClientType.COMPANY,
                    },
                    {
                        key: 'city',
                        label: 'labels.city',
                        advanced: true,
                        inputType: 'select',
                        translate: true,
                        entity: SelectApiClientType.CITY,
                    }
                )
            }
            filters.push(
                {
                    key: 'couponCode',
                    type: 'partial',
                    label: this.$t('labels.coupon_code'),
                    advanced: true,
                    inputType: 'search',
                },
                {
                    key: 'requiredDeliveryTime',
                    type: 'after',
                    label: 'labels.delivery_time_from',
                    // labels.delivery_date reads "Dropoff" (the list column)
                    rangeLabel: this.$te('labels.delivery_date_filter')
                        ? this.$t('labels.delivery_date_filter')
                        : 'Delivery date',
                    advanced: true,
                    inputType: 'date',
                    listener: 'requiredDeliveryTime',
                },
                {
                    key: 'requiredDeliveryTime',
                    type: 'before',
                    label: 'labels.delivery_time_until',
                    advanced: true,
                    inputType: 'date',
                    listener: 'requiredDeliveryTime',
                },
                {
                    key: 'createdAt',
                    type: 'after',
                    label: 'labels.order_date_from',
                    advanced: true,
                    inputType: 'date',
                },
                {
                    key: 'createdAt',
                    type: 'before',
                    label: 'labels.order_date_until',
                    advanced: true,
                    inputType: 'date',
                }
            )
            if (this.isSuperAdmin) {
                filters.push({
                    key: 'deliverectError',
                    label: 'labels.deliverect_error',
                    advanced: true,
                    value: 1,
                    inputType: 'checkbox',
                })
                filters.push({
                    key: 'restaurantCancellation',
                    label: 'labels.restaurant_cancellation_filter',
                    value: 1,
                    inputType: 'checkbox',
                    advanced: true,
                })
            }
            return filters
        },
    },
}
